import React from 'react';
import { Card } from '../../components/ui/card';

const TripDetailsCard = ({ pickup, dropoff }) => {
  return (
    <Card className="p-6">
      <h3 className="font-semibold text-gray-900 mb-4">Trip Details</h3>
      <div className="space-y-4">
        <div className="flex items-start gap-3">
          <div className="w-3 h-3 rounded-full bg-green-500 mt-1.5"></div>
          <div className="flex-1">
            <p className="text-sm text-gray-600">Pickup</p>
            <p className="font-medium text-gray-900">{pickup}</p>
          </div>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-3 h-3 rounded-full bg-red-500 mt-1.5"></div>
          <div className="flex-1">
            <p className="text-sm text-gray-600">Dropoff</p>
            <p className="font-medium text-gray-900">{dropoff}</p>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default TripDetailsCard;
